
import { Navigate } from "react-router-dom"
import { AuthJwtUser, getUserData } from "../helpers/Api"

export const ProtectedRoute = ({children,user,redirectTo="/"}) => {

    if(user === null) return <Navigate to={redirectTo} replace={true} />
    else return children;
}